export class User {
    public static LoadFromAdalUser(adUser: any): User {
        const user: User = new User();
        user.UserName = adUser.userName;
        if (adUser.profile) {
            user.FamilyName = adUser.profile.family_name;
            user.GivenName = adUser.profile.given_name;
            user.Name = adUser.profile.name;
            user.Roles = adUser.profile.roles;
            user.UniqueName = adUser.profile.unique_name;
        }

        return user;
    }

    public UserName: string = '';
    public FamilyName: string = '';
    public GivenName: string = '';
    public Name: string = '';
    public Roles: string[] = [];
    public UniqueName: string = '';

    public HasRole(roleName: string): boolean {
        if(this.Roles === undefined || this.Roles == undefined){
            return false;
            }

        return this.Roles.some((userRole) => {
            return userRole === roleName;
        });
    }
}
